// /src/pages/admin/Estandares.tsx
import React from 'react';
import {
  Box,
  Heading,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Text,
  Badge,
  VStack,
  HStack,
} from '@chakra-ui/react';
import { mockEstandares } from '../../mocks/estandares';

export const Estandares: React.FC = () => {
  return (
    <Box>
      <Heading size="lg" mb={6}>
        Gestión de Estándares
      </Heading>

      <VStack spacing={4} align="stretch">
        {mockEstandares.map((estandar) => (
          <Box key={estandar.id} bg="white" borderRadius="lg" boxShadow="sm" p={6}>
            <Heading size="md" mb={4} color="blue.600">
              {estandar.nombre}
            </Heading>

            <Accordion allowMultiple>
              {estandar.capitulos.map((capitulo) => (
                <AccordionItem key={capitulo.id} border="none" mb={2}>
                  <AccordionButton
                    bg="gray.50"
                    _hover={{ bg: 'gray.100' }}
                    borderRadius="md"
                    px={4}
                    py={3}
                  >
                    <Box flex="1" textAlign="left">
                      <HStack>
                        <Badge colorScheme="blue">{capitulo.lineamientos.length}</Badge>
                        <Text fontWeight="semibold">{capitulo.nombre}</Text>
                      </HStack>
                    </Box>
                    <AccordionIcon />
                  </AccordionButton>
                  <AccordionPanel pb={4} pt={4}>
                    <VStack align="stretch" spacing={3}>
                      {capitulo.lineamientos.map((lineamiento) => (
                        <Box
                          key={lineamiento.id}
                          p={4}
                          bg="gray.50"
                          borderRadius="md"
                          borderLeft="4px"
                          borderColor="blue.400"
                        >
                          <Text fontWeight="semibold" mb={2}>
                            {lineamiento.nombre}
                          </Text>
                          <Text fontSize="sm" color="gray.600">
                            {lineamiento.descripcion}
                          </Text>
                        </Box>
                      ))}
                    </VStack>
                  </AccordionPanel>
                </AccordionItem>
              ))}
            </Accordion>
          </Box>
        ))}
      </VStack>
    </Box>
  );
};
